
const Textarea = (props: any) => {

  let valueInput = props.value ?? '';
  let showCharacters = props.showCharacters ?? false;
  let maxLength = props.maxLength ?? 100;
  const UpdadeValue = (valueInput: any) => {
    props.handleChange(valueInput)
  }

  return (
    <>
      <textarea className="textArea w-100"
        value={valueInput}
        onChange={(e) => UpdadeValue(e.target.value)}
        rows={3}
        maxLength={maxLength}
      />
      {(showCharacters) &&
        <div className="text-right">
          <b className="showCharacters">{valueInput.length}/{maxLength}</b>
        </div>
      }
    </>
  )
}

export default Textarea;
